import script from "./TermsAndConditionsView.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsView.vue?vue&type=script&lang=js"

import "./TermsAndConditionsView.vue?vue&type=style&index=0&id=28eb8dbe&lang=scss"

const __exports__ = script;

export default __exports__